import { HDate } from '@hebcal/core';

/**
 * Compute prayer additions (Ya'aleh V'Yavo, Al HaNisim, Anenu, Nachem).
 *
 * @param {HDate} hdate
 * @param {object} calData - from calendarProvider
 * @returns {object} prayer addition flags
 */
export function computePrayerAdditions(hdate, calData) {
  const m = hdate.getMonth();
  const d = hdate.getDate();

  // Ya'aleh V'Yavo: RC, Chol HaMoed, Yom Tov
  let yaalehVeyavo = false;
  let yaalehVeyavoReason = null;
  if (calData.isRoshChodesh) {
    yaalehVeyavo = true;
    yaalehVeyavoReason = 'ר״ח';
  } else if (calData.isCholHamoed) {
    yaalehVeyavo = true;
    yaalehVeyavoReason = 'חול המועד';
  } else if (calData.isYomTov) {
    yaalehVeyavo = true;
    yaalehVeyavoReason = 'יום טוב';
  }

  // Al HaNisim
  let alHanisim = false;
  let alHanisimReason = null;
  if (calData.isChanukah) {
    alHanisim = true;
    alHanisimReason = 'חנוכה';
  }
  // Purim: 14 Adar (or Adar II in leap year)
  const adarMonth = HDate.isLeapYear(hdate.getFullYear()) ? 13 : 12;
  if (m === adarMonth && d === 14) {
    alHanisim = true;
    alHanisimReason = 'פורים';
  }

  // Anenu: fast days
  let anenu = null;
  if (calData.isFastDay) {
    const isNidcheh = calData.holidays.some(h => h.category === 'fast' && h.isNidcheh);
    anenu = {
      applicable: true,
      shacharit: 'shatz_only',
      mincha: 'everyone',
      isNidcheh,
    };
  }

  // Nachem: mincha of Tisha B'Av only (including nidcheh)
  let nachem = false;
  const isTishaBAv = calData.holidays.some(h =>
    h.nameEn.includes("Tish'a B'Av") || h.nameEn.includes("Erev Tish'a B'Av")
  );
  // 9 Av or nidcheh (10 Av)
  if (m === 5 && (d === 9 || d === 10) && isTishaBAv) {
    nachem = true;
  }

  return {
    yaalehVeyavo,
    yaalehVeyavoReason,
    alHanisim,
    alHanisimReason,
    anenu,
    nachem,
  };
}
